import { memo } from 'react';

interface AuthContainerProps {
  children: React.ReactNode;
}

export const AuthContainer = memo(({ children }: AuthContainerProps) => (
  <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    {children}
  </div>
));

AuthContainer.displayName = 'AuthContainer';